<template>
  <div class="bottom-block">
    <hr>
    <el-button
      :disabled="aiTemplateLoader"
      type="plain"
      class="small"
      @click="$router.go(-1)"
    >
      {{ $t('back') }}
    </el-button>
  </div>
</template>

<script>
import MixinAiTemplate from '@/mixins/aiTemplate'

export default {
  name: 'BottomBackBlock',

  mixins: [MixinAiTemplate]
}
</script>
